import React, { useEffect, useCallback } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useLanguage } from '@/contexts/LanguageContext';
import { supportedLanguages } from '@/contexts/LanguageContext';

const LanguageAuthSync = () => {
  const { user, profile } = useAuth();
  const { language, changeLanguage } = useLanguage();

  // Note: We no longer update the user's preferred language when they change languages
  // The preferred language remains intact in their profile, while current language
  // selection is tracked separately in localStorage

  // Apply user's preferred language ONLY on initial login (not on every render)
  useEffect(() => {
    if (user && profile && profile.preferred_language) {
      const preferredLang = profile.preferred_language;
      const currentSavedLang = localStorage.getItem('appLanguage');
      
      // Only apply preferred language if there's no saved language preference
      // This means it's the first time the user is logging in after the preferred language was set
      if (!currentSavedLang && supportedLanguages.some(l => l.code === preferredLang) && preferredLang !== language) {
        console.log(`Applying user's preferred language on initial login: ${preferredLang}`);
        changeLanguage(preferredLang);
      } else if (currentSavedLang) {
        console.log(`User has saved language preference: ${currentSavedLang}, not overriding with preferred language`);
      }
    }
  }, [user, profile]); // Only depend on user and profile, not language

  // Don't update user's profile when language changes - keep preferred language intact
  // The current language selection is tracked separately in localStorage

  return null; // This component doesn't render anything
};

export default LanguageAuthSync;
